// src/pages/NotFound.tsx
import React from "react";
import { Stack, Text, PrimaryButton } from "@fluentui/react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Stack verticalAlign="center" horizontalAlign="center" style={{ height: "100vh" }} tokens={{ childrenGap: 20 }}>
      <Text variant="xxLarge">❓ 404 - ページが見つかりません</Text>
      <Text>お探しのページは存在しません。</Text>
      <PrimaryButton text="ホームに戻る" onClick={() => navigate("/shokai")} />
    </Stack>
  );
};

export default NotFound;
